export const replaceAll = (
  value: string,
  replaceFrom: string,
  replaceTo: string
) => value.split(replaceFrom).join(replaceTo);

export const isMobile = () =>
  typeof window !== "undefined" && window.innerWidth < 450;
